'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Controller2 = require('./Controller');

var _Controller3 = _interopRequireDefault(_Controller2);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UniversalController = function (_Controller) {
  _inherits(UniversalController, _Controller);

  function UniversalController(rootModule, controllerOptions) {
    _classCallCheck(this, UniversalController);

    var _this = _possibleConstructorReturn(this, (UniversalController.__proto__ || Object.getPrototypeOf(UniversalController)).call(this, rootModule, controllerOptions));

    _this.changes = [];
    _this.model.state = JSON.parse(JSON.stringify(_this.model.state));
    _this.trackChanges = _this.trackChanges.bind(_this);
    _this.on('flush', _this.trackChanges);
    _this.hasRun = false;
    return _this;
  }

  _createClass(UniversalController, [{
    key: 'trackChanges',
    value: function trackChanges(changes) {
      this.changes = this.changes.concat(changes);
    }
  }, {
    key: 'getChanges',
    value: function getChanges() {
      var _this2 = this;

      return this.changes.reduce(function (changes, change) {
        changes[change.path.join('.')] = _this2.getState(change.path);

        return changes;
      }, {});
    }
  }, {
    key: 'getScript',
    value: function getScript() {
      var state = JSON.stringify(this.getChanges());

      this.hasRun = true;
      return '<script>window.CEREBRAL_STATE = ' + state + '</script>';
    }
  }, {
    key: 'runSequence',
    value: function runSequence(sequence, payload) {
      var signalRun = void 0;

      if (Array.isArray(sequence)) {
        signalRun = this.run('UniversalController.run', sequence, payload);
      } else if (typeof sequence === 'string') {
        var pathArray = (0, _utils.ensurePath)(sequence);
        var signalKey = pathArray.pop();
        var module = (0, _utils.getModule)(pathArray, this.module);
        var signalDefinition = module && module.signals[signalKey];

        signalRun = this.run(sequence, signalDefinition.signal, payload);
      } else {
        (0, _utils.throwError)('Sequence must be a signal-path or an array of action.');
      }

      return signalRun;
    }
  }, {
    key: 'setState',
    value: function setState(path, value) {
      this.model.set((0, _utils.ensurePath)(path), value);
      this.flush(true); // Track changes.
    }
  }]);

  return UniversalController;
}(_Controller3.default);

exports.default = UniversalController;
//# sourceMappingURL=UniversalController.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/UniversalController.js
// module id = 256
// module chunks = 0